<!DOCTYPE html>
<app-dataview [identifier]="'activities-view'" [title]="title" [treedata]="menuItems" [showtree]="true" [sidepaneltitle]="'Activities'" [url]="url"></app-dataview>